import { connect } from "react-redux";
import { isRendered } from "../../state/modules/adverts";
import AdvertSwitch from "./AdvertSwitch";

const mapStateToProps = (state, { Advert }) => ({
  hasAdverts: !!Advert && isRendered(state)
});

export default component => connect(mapStateToProps)(AdvertSwitch(component));
